import script from "./GeneralSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&setup=true&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=149c5002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149c5002"]])

export default __exports__